import React from "react"
import { RouteObject } from "react-router-dom"
import NewTenantComponent from "../component/new-tenant-component"
import TenantPage from "../page/tenant.page"
import AuthGuard from "../../../shared/auth/component/auth"
export const TenantRoute: RouteObject = {
  path: "/tenant",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-tenants", "view-tenants"]}>
      <TenantPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewTenantComponent editMode="detail" />,
    },
    { path: ":id", element: <NewTenantComponent editMode="new" /> },
  ],
}
